import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTerraform = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 58,
	viewBox: "0 0 58 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0908 37.4365L53 28.8364V11.6091L38.0908 20.2273V37.4365Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5455 11.6091L36.4546 20.2273V37.4365L21.5455 28.8273M5 19.2182L19.9091 27.8273V10.6091L5 2M21.5455 47.9365L36.4546 56.5456V39.3274L21.5455 30.7183",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgTerraform);
export { ForwardRef as ReactComponent };
